import { render, staticRenderFns } from "./CUserSettings.vue?vue&type=template&id=719826cb&scoped=true&"
import script from "./CUserSettings.vue?vue&type=script&lang=js&"
export * from "./CUserSettings.vue?vue&type=script&lang=js&"
import style0 from "./CUserSettings.vue?vue&type=style&index=0&id=719826cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719826cb",
  null
  
)

export default component.exports